import { wrapperBuilder } from './build';
const variables = wrapperBuilder.getVariablesRegisterInstance();

variables.addVariable('value', wrapperEnvironment => ({
  startValue:
    (wrapperEnvironment.state?.anotherLastActionDispatched || '') +
    '>' +
    wrapperEnvironment.componentProps.valueToConcat,
}));
